import { render, staticRenderFns } from "./loginhead.vue?vue&type=template&id=131d11b8&"
import script from "./loginhead.vue?vue&type=script&lang=js&"
export * from "./loginhead.vue?vue&type=script&lang=js&"
import style0 from "./loginhead.vue?vue&type=style&index=0&lang=less&scoed=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports